import "./style.scss";
import { Breadcrumb, Pagination } from "rsuite";
import { Button } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { Car } from "../../redux/cars/types/car";
import { getLocalized } from "../../redux/localization";
import {
  getCarLookupList,
  getFilterCarList,
  getModelList,
} from "../../redux/cars";
import { useLocation } from "react-router-dom";
import CustomCheckPicker from "./check-picker";
import { CarLookup } from "../../redux/cars/types/carLookup";
import { Model } from "../../redux/cars/types/model";
import CarCard from "../../components/car-card";
import { ButtonType } from "../../components/button";
import { BsArrowRight } from "react-icons/bs";
import CustomLoader from "../../components/loader";
import ResponsiveFilterDrawer from "./resposiveFilter";

const FilterPage = () => {
  const [carlookup, setCarlookup] = useState<CarLookup>();
  const dispatch = useDispatch();
  const [cars, setCars] = useState<Car[]>([]);
  const localize = useSelector(getLocalized);
  const location = useLocation<any>();
  const [pageNumber, setPageNumber] = useState(1);
  const [models, setModels] = useState<Model[]>([]);
  const [loader, setLoader] = useState(false);
  function getData() {
    return cars.filter((v, i) => {
      const start = 6 * (pageNumber - 1);
      const end = start + 6;
      return i >= start && i < end;
    });
  }
  useEffect(() => {
    setLoader(true);
    dispatch(
      getFilterCarList({
        payload: {
          onSuccess: (message, payload) => {
            setCars(payload);
            setLoader(false);
          },
          onError: (message) => {},
        },
        url:
          "api/car/filter" +
          (location.search
            ? location.search
            : `?brand=${undefined}&model=${undefined}&bodyType=${undefined}&gearType=${undefined}&fuelType=${undefined}`),
      })
    );
    dispatch(
      getModelList({
        payload: {
          onSuccess: (message, payload) => {
            setModels(payload);
            const array = payload;
            dispatch(
              getCarLookupList({
                payload: {
                  onSuccess: (message, payload) => {
                    setCarlookup({
                      Brands: payload.Brands,
                      BodyTypes: payload.BodyTypes,
                      Cars: payload.Cars,
                      FuelTypes: payload.FuelTypes,
                      GearTypes: payload.GearTypes,
                      KMLimits: payload.KMLimits,
                      Periods: payload.Periods,
                      CarModels: array,
                    });
                  },
                  onError: (message) => {},
                },
                url: "api/car/carlookupdetails",
              })
            );
          },
          onError: (message) => {},
        },
        url: "api/car/definitions/model",
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const AlwaysScrollToBottom = () => {
    const elementRef = useRef(null);
    useEffect(() =>
      //@ts-ignore
      elementRef.current.scrollIntoView()
    );
    return <div ref={elementRef} />;
  };
  return (
    <>
      <AlwaysScrollToBottom />
      <ResponsiveFilterDrawer
        setCars={setCars}
        setPageNumber={setPageNumber}
        carlookup={carlookup}
        models={models}
        setModels={setModels}
      />
      <div className="container ">
        {loader && <CustomLoader />}
        <div className="w-100 d-flex justify-content-between my-4">
          <h2 className="header-font">
            <div className="breadcrumb">
              <Breadcrumb>
                <Breadcrumb.Item href="/" className="breadCrumbText">
                  {localize.getString("home")}
                </Breadcrumb.Item>
                <Breadcrumb.Item active className="breadCrumbText">
                  {localize.getString("filterresult")}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </h2>
          <Button
            buttonType={ButtonType.new}
            icon={<BsArrowRight />}
            title={"TÜM ARAÇLARI GÖSTER"}
            onClick={() => {
              setLoader(true);
              dispatch(
                getFilterCarList({
                  payload: {
                    onSuccess: (message, payload) => {
                      setCars(payload);
                      setLoader(false);
                    },
                    onError: (message) => {},
                  },
                  url: `api/car/filter?brand=${undefined}&model=${undefined}&bodyType=${undefined}&gearType=${undefined}&fuelType=${undefined}`,
                })
              );
            }}
          />
        </div>

        <div className="w-100 flex-column">
          <div className="w-100 d-flex justify-content-between ">
            <div className="marginInlineEnd50">
              <CustomCheckPicker
                carlookup={carlookup}
                models={models}
                setModels={setModels}
                setCars={setCars}
                setPageNumber={setPageNumber}
              />
            </div>
            <div className="w-100">
              <div className="carList w-100 d-flex  flex-wrap gap-5 ">
                {getData().map((car, i) => (
                  <CarCard key={i} data={car} />
                ))}
              </div>
            </div>
          </div>
          <div className="filter-page-pagging">
            <Pagination
              prev
              next
              activePage={pageNumber}
              size="lg"
              total={Math.ceil(cars.length / 6)}
              limit={1}
              onChangePage={(page: number) => setPageNumber(page)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default FilterPage;
